import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import updateWholesaler from '@/API/Wholesaler/updateWholesaler';
import {
    getBillingNotesByMode,
    handleBillingNotesCRUD,
} from '../utils/billingNotesHandler';
import { transformFormDataForUpdate } from '../utils/wholesalerFormUtils';

const useUpdateWholesaler = (
    formData,
    resetToMainTable,
    deletedBillingNoteIDs,
    initialFormData,
) => {
    const queryClient = useQueryClient();
    const { restError } = useSelector((state) => state.modal);

    return useMutation({
        mutationFn: async () => {
            const response = await updateWholesaler(
                transformFormDataForUpdate(formData),
            );

            const initialBillingNotes = getBillingNotesByMode(
                initialFormData,
                'Wholesaler',
            );
            const billingNotes = getBillingNotesByMode(formData, 'Wholesaler');

            if (billingNotes?.length || deletedBillingNoteIDs?.length) {
                await handleBillingNotesCRUD(
                    billingNotes,
                    initialBillingNotes,
                    deletedBillingNoteIDs,
                );
            }

            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['wholesalers'] });
            queryClient.invalidateQueries({
                queryKey: ['wholesaler', formData.id],
            });
            if (resetToMainTable) {
                resetToMainTable();
            }
            toast.success('Updated wholesaler successfully');
        },
        onError: (error) => {
            if (error?.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors)
                    ?.flat()
                    .join('\n');
                toast.error(errorMessages);
            } else if (restError) {
                toast.error(restError);
            } else {
                toast.error(
                    error?.response?.data?.title ||
                        error?.message ||
                        'Failed to update wholesaler',
                );
            }
        },
        staleTime: 0,
    });
};

export default useUpdateWholesaler;
